import { SubscriptionPlan } from './subscriptionPlan';

export class UserSubscription {
    id: number;
    user_id: number;
    subscription_id: string;
    plan_id: number;
    description: string;
    stripe_payment_method: string;
    plan: SubscriptionPlan;
    status:string;
    sub_until;
    quantity:number;
    constructor(subscription?) {
        if (subscription) {
            this.id = subscription.id;
            this.user_id = subscription.user_id;
            this.subscription_id = subscription.subscription_id;
            this.plan_id = subscription.plan_id;
            this.description = subscription.description;
            this.stripe_payment_method = subscription.stripe_payment_method;
            this.plan = subscription.plan || null;
            this.status = subscription.status;
            this.sub_until=subscription.sub_until;
            this.quantity=subscription.quantity;
        }
    }
}
